export const shopCategories = [
  {
    title: "Living Room",
    links: ["Sofas & Sectionals", "Coffee Tables", "TV Units", "Recliners", "Side Tables"],
  },
  {
    title: "Bedroom",
    links: ["Beds", "Wardrobes", "Nightstands", "Dressers", "Mattresses"],
  },
  {
    title: "Dining",
    links: ["Dining Tables", "Dining Chairs", "Bar Stools", "Sideboards"],
  },
  {
    title: "Office",
    links: ["Office Chairs", "Desks", "Bookshelves", "Filing Cabinets"],
  },
  {
    title: "Outdoor",
    links: ["Patio Furniture", "Garden Chairs", "Outdoor Tables", "Umbrellas"],
  },
];

export const category = [
  {
    title: "Furniture",
    links: ["Living Room", "Bedroom", "Dining Room", "Office", "Outdoor"],
  },
  {
    title: "Decor",
    links: ["Wall Art", "Clocks", "Vases", "Mirrors", "Lamps"],
  },
  {
    title: "Lighting",
    links: ["Ceiling Lights", "Table Lamps", "Floor Lamps", "Wall Lights"],
  },
  {
    title: "Storage",
    links: ["Shelves", "Cabinets", "Bookcases", "Shoe Racks"],
  },
  {
    title: "Accessories",
    links: ["Rugs", "Cushions", "Throws", "Curtains"],
  },
];

export const supportCategories = [
  {
    title: "Customer Service",
    links: [
      "Contact Us",
      "Order Tracking",
      "Shipping Information",
      "Returns & Exchanges",
      "FAQs",
    ],
  },
  {
    title: "Warranty & Repairs",
    links: [
      "Product Warranty",
      "Repair Services",
      "Claim Warranty",
    ],
  },
  {
    title: "Policies",
    links: [
      "Privacy Policy",
      "Terms & Conditions",
      "Return Policy",
      "Shipping Policy",
    ],
  },
  {
    title: "Resources",
    links: [
      "Furniture Care",
      "Assembly Guides",
      "Size Guide",
      "Blog",
    ],
  },
  {
    title: "Corporate",
    links: [
      "About Us",
      "Careers",
      "Investor Relations",
      "Affiliate Program",
    ],
  },
];


  